import RelatedArticlesComponent from "../../../../components/help/RelatedArticlesComponent.tsx";

export default function FirmaBetaltArticle() {
    return (
        <>
            <article className="help-article-content">
                <div className="article">
                    <div className="text-box text-box--gray">
                        <p>
                            Vi vil gerne hjælpe med firmabetalt internet.
                            Du skal dog være opmærksom på, at din regning kun kan blive betalt med et betalingskort &ndash; ikke PBS.
                        </p>
                    </div>
                </div>

                <div className="article">
                    <div className="paragraph">
                        <h2>Hvordan kan min arbejdsgiver betale mit abonnement?</h2>
                        <p>
                            Hvis din arbejdsgiver ikke har en erhvervsaftale med os, skal du selv aftale, hvordan betalingen skal foregå med din arbejdsgiver.
                        </p>
                        <p>Betalingen kan ske på to måder:</p>
                        <ul className="list list--number">
                            <li>
                                <p>Du betaler med dit eget betalingskort.</p>
                                <ul className="list list--bullet list--compact">
                                    <li><p>Du håndterer regningen internt med din arbejdsgiver.</p></li>
                                    <li><p>Du kan hver måned finde din regning i Mit Hiper.</p></li>
                                </ul>
                            </li>
                            <li>
                                <p>Din arbejdsgiver betaler med et betalingskort.</p>
                                <ul className="list list--bullet list--compact">
                                    <li><p>Du kan hver måned finde din regning i Mit Hiper.</p></li>
                                </ul>
                            </li>
                        </ul>
                        <p>
                            Vi kan tilføje relevant firmainformation, som f.eks. CVR og firmanavn, på kvitteringen.
                        </p>
                    </div>
                </div>

                <div className="article">
                    <div className="paragraph">
                        <h2>Hvordan betaler min arbejdsgiver for mit abonnement?</h2>
                        <ul className="list list--number">
                            <li>
                                <p>Send en mail til <a href="mailto:kundeservice@hiper.dk">kundeservice@hiper.dk</a> fra mailadressen registreret på dit abonnement.
                                </p>
                            </li>
                            <li>
                                <p>Sæt din arbejdsgiver som CC, så de kan bekræfte, at de ønsker at overtage betalingen via automatisk kortbetaling.</p>
                            </li>
                            <li>
                                <p>Tilføj følgende informationer i mailen:</p>
                                <ul className="list list--bullet">
                                    <li>
                                        <p>Dine privatoplysninger:</p>
                                        <ul className="list list--bullet list--compact">
                                            <li><p>Dit fulde navn</p></li>
                                            <li><p>Dit telefonnummer</p></li>
                                            <li><p>Din emailadresse</p></li>
                                        </ul>
                                    </li>
                                    <li>
                                        <p>Faktureringsoplysninger på din arbejdsgiver:</p>
                                        <ul className="list list--bullet list--compact">
                                            <li><p>CVR-nummer</p></li>
                                            <li><p>Firmanavn</p></li>
                                            <li><p>Telefonnummer til fakturering</p></li>
                                            <li><p>Emailadresse til fakturering</p></li>
                                            <li><p>Faktureringsadresse</p></li>
                                        </ul>
                                    </li>
                                </ul>
                            </li>
                            <li>
                                <p>Efterfølgende skal I ind på Mit Hiper og tilføje det betalingskort, som I ønsker regningen skal trækkes fra.</p>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="article">
                    <div className="paragraph">
                        <h2>Vær opmærksom på, at betalingen fortsat skal ske via betalingskort</h2>
                        <p>
                            Enten skal dit eget betalingskort være tilknyttet og så koordinerer du betaling internt med din arbejdsgiver.
                            Din arbejdsgiver kan også tilknytte et betalingskort til abonnementet, hvor regningen bliver trukket fra hver måned.
                        </p>
                    </div>
                </div>

                <div className="article">
                    <div className="paragraph">
                        <h2>Din arbejdsgiver kan også indgå en firmaaftale med os</h2>
                        <p>
                            Til at starte med er det en god idé og forhøre din arbejdsgiver, om de i forvejen har en aftale med os.
                            Hvis de har en aftale, kan din arbejdsgiver kontakte os vedr. et abonnement.
                        </p>
                        <p>
                            Ønsker jeres firma en firmaaftale med Hiper, så kontakt os på <a href="mailto:erhverv@hiper.dk">erhverv@hiper.dk</a> for tilbud og muligheder.
                        </p>
                    </div>
                </div>
            </article>

            <RelatedArticlesComponent
                articles={[
                    {
                        "category": "regning-og-betaling",
                        "article": "betalingsmuligheder",
                        "name": "Betalingsmuligheder"
                    },
                    {
                        "category": "regning-og-betaling",
                        "article": "forstaa-din-regning",
                        "name": "Forstå din regning"
                    },
                    {
                        "category": "regning-og-betaling",
                        "article": "mistet-kort",
                        "name": "Jeg har mistet mit betalingskort"
                    },
                    {
                        "category": "mit-abonnement",
                        "article": "mit-hiper",
                        "name": "Mit Hiper"
                    }
                ]}
            />
        </>
    )
}
